<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">操作日志</div>
          <div class="card-body">
            <Table :columns="columns" :data="data" border> </Table>
            <div class="paging">
              <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getLog
  } from "@/api/admin";
  export default {
    data() {
      return {
        columns: [
          {
            title: "操作时间",
            align: "center",
            minWidth: 180,
            key: "time",
          }, {
            title: "操作IP",
            align: "center",
            minWidth: 120,
            key: "ip",
          },
          {
            title: "操作内容",
            align: "center",
            minWidth: 200,
            key: "explain",
          },

        ],
        pageIndex: 1,
        pageSize: 10,
        total: "",
        data: [],
      };
    },
    created() {
      this._getData();
    },

    methods: {
      // 获取列表
      _getData() {
        getLog({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
        });
      },
      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this._getData();
      },
      pageSizeChange(val) {
        this.pageSize = val;
        this._getData();
      },
    },
  };
</script>

<style lang="less" scoped>
</style>